import React, { Component } from 'react'
import classes from './logedinreset.module.css'
import {Modal,Card, Container, Form, Button, Col, Row, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionTypes from '../../Action/Index';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner'
import queryString from 'query-string';
import src from '../../Assets/Images/Successmdpi.png'
import Cookies from 'universal-cookie';
export class LogedinReset extends Component {
    state = {
        type: 'password',
        confirmType: 'password',
        currentType:'password',
        secondWindow: false,
        passwordMisMatch: false,
        token:'',
        email:'',
        resetmsg:'',
        show:false,
        id:'',
        modalshow:false,

    }
   
    passwordChangedHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
     
        if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/.test(e.target.currentpassword.value)) {
            this.setState({
                currentpasswordErrMsg: "Password should be between 8-15 characters with atleast one upper case,lower case,one digit and one special character."
            })
        }
       else if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/.test(e.target.password.value)) {
            this.setState({
                passwordErrMsg: "Password should be between 8-15 characters with atleast one upper case,lower case,one digit and one special character."
            })
        }
       else{
       if(e.target.password.value === e.target.confirmPassword.value){
        this.setState({
            passwordMisMatch: false,
            resetmsg:"",
            show:false,
        })
        this.props.logedinresetEployer(e.target.currentpassword.value,e.target.password.value,e.target.confirmPassword.value)
    } 
    else{
       this.setState({
           passwordMisMatch: true,
           resetmsg:"",
           show:true,
       })
    }
    }
   
}

currentpasswordFormatChangedHandler = () => {
   
    if (this.state.currentType === 'password') {
        this.setState({
            currentType: 'text'
        })

        document.getElementById('currentpassword').classList.add("fa-eye");
        document.getElementById('currentpassword').classList.remove("fa-eye-slash");
    }
    else {
        this.setState({
            currentType: 'password'
        })
        document.getElementById('currentpassword').classList.remove("fa-eye");
        document.getElementById('currentpassword').classList.add("fa-eye-slash");
    }
}

    passwordFormatChangedHandler = () => {
       
        if (this.state.type === 'password') {
            this.setState({
                type: 'text'
            })

            document.getElementById('password').classList.add("fa-eye");
            document.getElementById('password').classList.remove("fa-eye-slash");
        }
        else {
            this.setState({
                type: 'password'
            })
            document.getElementById('password').classList.remove("fa-eye");
            document.getElementById('password').classList.add("fa-eye-slash");
        }
    }

    confirmPasswordFormatChangedHandler = () => {
       
        if (this.state.confirmType === 'password') {
            this.setState({
                confirmType: 'text'
            })

            document.getElementById('confirm_password').classList.add("fa-eye");
            document.getElementById('confirm_password').classList.remove("fa-eye-slash");
        }
        else {
            this.setState({
                confirmType: 'password'
            })
            document.getElementById('confirm_password').classList.remove("fa-eye");
            document.getElementById('confirm_password').classList.add("fa-eye-slash");
        }
    }
      
    

     setShow() {
        this.setState({
            show: false,
        })
    }

     passwordLength = (e, len2) =>
    {
        if (e.target.value.length >= len2 && e.which !== 8 )
        {
            e.preventDefault();
           
        }
      
    }

    inputMethod=(event)=>{
        let nm=event.target.name;
        let valu=event.target.value;
        this.setState({[nm]:valu})
      }

    componentWillReceiveProps(nextProps){
        if(nextProps.errorMsg!=null){
           
            this.setState ({resetmsg:nextProps.errorMsg.message,show:true});
        }
        if(nextProps.getApiStatus){
            this.setState ({modalshow:nextProps.getApiStatus});
        }
    }

     handleClose = () => {
        document.getElementById("_password").value=""
        document.getElementById('_currentpassword').value=""
        document.getElementById('_confirmpassword').value=""
        localStorage.clear()
        new Cookies().remove('orderId')
        new Cookies().remove('mode')
         this.props.history.push('/login')
         this.setState({modalshow:false})
     }

    render() {
        console.log('loader',this.props.loader)
        return (
            
              <div>  
                    <h3 className={classes.reserHeading}>Reset Password</h3>

                    <Container style={{ padding: '8%' }} fluid>
                        <Row className="justify-content-center ">
                            <Col md={7}>
                                <Card>
                                    <Card.Body>
                                       
                                        {this.state.show ?
                                            <div>
                                        <div className={classes.alerMainBox}>
                                            <div className={classes.alert}>
                                                <p className={classes.closebtn} onClick={() => this.setShow()} >&times;</p>
                                            </div>
                                            <div className={classes.messageBox}>

                                            <span className={classes.passwordMismatch}> &nbsp; {this.state.passwordMisMatch ? 'Passwords did not match' : null }</span>
                                            
                                            <span className={classes.expireMsg}>{this.state.resetmsg}</span>
                                            </div>
                                          
                                        </div>
                                        <br/>
                                        </div>
                                        : null}
                                        <Card.Text>
                                            <Form onSubmit={(e) => this.passwordChangedHandler(e)}>

                                            <Form.Group className={` mb-4 ${classes.formGroup}`}>
                                                    <label className="has-float-label">
                                                        <input type={this.state.currentType} id="_currentpassword" placeholder=" " required
                                                            style={{marginBottom: 'auto'}}
                                                            autoComplete="off" name="currentpassword" 
                                                            onInput={() => this.setState({currentpasswordErrMsg: ""})}
                                                            maxLength="15"
                                                            
                                                        />
                                                        <span style={{color: 'gray',fontWeight: '700'}}>Current Password</span>
                                                    </label>
                                                   
                                                    <span toggle="#password-field" className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                                                        id="currentpassword" onClick={this.currentpasswordFormatChangedHandler}></span>
                                                         <span className = {classes.PasswordValidation}>{this.state.currentpasswordErrMsg}</span>
                                                </Form.Group>

                                                <Form.Group className={` mb-4 ${classes.formGroup}`}>
                                                    <label className="has-float-label">
                                                        <input type={this.state.type} id="_password" placeholder=" " required
                                                             style={{marginBottom: 'auto'}}
                                                            autoComplete="off" name="password" 
                                                            onInput={() => this.setState({passwordErrMsg: ""})}
                                                            maxLength="15"
                                                        />
                                                         <span style={{color: 'gray',fontWeight: '700'}}>New Password</span>
                                                    </label>
                                                   
                                                    <span toggle="#password-field" className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                                                        id="password" onClick={this.passwordFormatChangedHandler}></span>
                                                         <span className = {classes.PasswordValidation}>{this.state.passwordErrMsg}</span>
                                                </Form.Group>

                                                <Form.Group className={` ${classes.formGroup}`}>
                                                    <label className="has-float-label">
                                                        <input type={this.state.confirmType} id="_confirmpassword" placeholder=" " required
                                                         style={{marginBottom: 'auto'}}
                                                            autoComplete="off" name="confirmPassword" 
                                                            onInput= {() => this.setState({passwordErrMsg: ""})}
                                                            maxLength="15"
                                                        />
                                                         <span style={{color: 'gray',fontWeight: '700'}}>Confirm New Password</span>
                                                    </label>
                                                    <span toggle="#password-field" className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                                                        id="confirm_password" onClick={this.confirmPasswordFormatChangedHandler}>
                                                    </span>
                                                  
                                                </Form.Group>
                                                <br/>
                                                <Row>
                                           <Col lg={4} md={12} sm={12}> <span className={classes.spinner}>{this.props.loader?<Spinner animation="border" variant="warning" />:null}</span>
                                           </Col>  
                                           <Col lg={6} md={6} sm={6}><Button variant="warning text-white" className={classes.Button2}
                                                        type="submit" disabled={this.props.loader}>Save Changes</Button></Col>
                                                </Row>
                                            </Form>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                    <Modal show={this.state.modalshow} centered>
                    <Modal.Body>
                    <Row>
                            <Col className="d-flex justify-content-center">
                              <img src={src}  width="58px"/> 
                            </Col>
                        </Row>
                       
                        <Row>
                            <Col md={12} className="text-center">
                               <span className="d-flex justify-content-center" style={{fontSize:"18px",fontWeight:"bold",marginTop: '12px'}}>Success!</span>
                               
                               <span>Password has been changed successfully.</span>
                               <br/>
                               <Button variant="warning text-white" className={classes.okbutton}
                               onClick={this.handleClose}
                               >OK</Button>
                            </Col>
                        </Row>
                    </Modal.Body>
                    </Modal>
                </div>
        )
    }
}


const mapStateToProps = state => {
    return{
     getApiStatus : state.employeeReducer.empresetSuccess,
     loader: state.employeeReducer.empresetLoader,
     errorMsg:state.employeeReducer.empresetErrorMsg,
    }
  }
  const mapDispatchToProps = dispatch => {
    return{
        logedinresetEployer: (current,newpass,confirm) => dispatch(actionTypes.logedinresetEployer(current,newpass,confirm)),
    
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(LogedinReset);